import { GolfPricingApi } from '@img-arena/consoles-api-golf-pricing'
import { useAuthStore } from '@/stores/useAuthStore'

import { logoutOnUnauthorized } from './interceptors/logoutOnUnauthorized'
// In here there is an instance of Golf Pricing Api definition
// Please use it in each place of the application for any api call to Golf Pricing from ops-console

export const golfPricingApi = new GolfPricingApi(
  {
    baseURL: import.meta.env.VITE_GOLF_PRICING_API,
    getToken: () => useAuthStore.getState().token
  },
  logoutOnUnauthorized
)
